export const WAITING = 'waiting';
export const ERROR = 'ERROR';
export const NOTIFICATION = 'NOTIFICATION';




// WEBPACK FOOTER //
// ./src/actions/types.js